import React, {Component} from 'react'

export default class CustomError extends Component {
    render() {
        return (<div>A custom error has been rendered</div>)
    }
}


// WEBPACK FOOTER //
// ./src/components/error.js